module.exports = __webpack_public_path__ + "img/folder.c7e39023.svg";